import { Box, Heading } from '@chakra-ui/react';

interface BoxFaturaProps {
  title: string;
  paga?: boolean;
  subtitle?: string;
  onPress: () => void;
  active?: boolean;
  color: string;
}

export function BoxFatura({ title, paga, subtitle, onPress, active, color }: BoxFaturaProps) {
  return (
    <Box
      as="button"
      onClick={onPress}
      borderRadius="lg"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
      backgroundColor="white"
      overflow="hidden"
      padding="16px"
      width="fit-content"
      border={`2px solid ${active ? color : 'white'}`}
      minWidth="170px"
      maxWidth="170px"
      minHeight="120px"
      position="relative"
      transition="all 0.2s ease-in-out"
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      }}
    >
      <Box
        position="absolute"
        bottom="12px"
        right="12px"
        backgroundColor={paga ? '#10B981' : '#F59E0B'}
        color="white"
        px="8px"
        py="4px"
        borderRadius="full"
        fontSize="12px"
        fontWeight="600"
        textTransform="uppercase"
        letterSpacing="0.5px"
        boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
      >
        {paga ? 'Pago' : 'Pendente'}
      </Box>

      <Box width="100%" mt="8px">
        <Heading
          textTransform="capitalize"
          color={active ? color : '#292927'}
          fontWeight="600"
          textAlign="left"
          fontSize="18px"
          mb="4px"
          lineHeight="1.2"
        >
          {title}
        </Heading>
        {subtitle && (
          <Heading
            color={active ? color : '#747474'}
            fontWeight="600"
            textAlign="left"
            fontSize="16px"
            opacity={0.8}
            mb="8px"
          >
            {subtitle}
          </Heading>
        )}
      </Box>

      <Box
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        height="4px"
        backgroundColor={paga ? '#10B981' : '#F59E0B'}
      />
    </Box>
  );
}
